import { useQuery } from "@tanstack/react-query";
import { getPrescriptionDetail } from "../services/ePrescriptionDetailService";

export const usePrescriptionDetail = (
  prescriptionId?: string,
  token?: string | null
) => {
  return useQuery({
    queryKey: ["prescription-detail", prescriptionId],
    queryFn: () => getPrescriptionDetail(prescriptionId!, token!),

    enabled: !!prescriptionId && !!token,

    staleTime: 0,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};